import React from 'react';
import { Form, Input, Button, Checkbox, message } from 'antd';
import { authService } from '../../services/authService';

const Login = ({ onLoginSuccess }) => {
  const onFinish = async (values) => {
    try {
      const user = await authService.login(
        values.username, 
        values.password,
        values.rememberMe
      );
      message.success('登录成功');
      onLoginSuccess(user);
    } catch (error) {
      message.error('登录失败: ' + error.message);
    }
  };

  return (
    <div style={{ maxWidth: 300, margin: '100px auto' }}>
      <h2 style={{ textAlign: 'center', marginBottom: 24 }}>汇丰驾校管理系统</h2>
      <Form onFinish={onFinish} initialValues={{ rememberMe: false }}>
        <Form.Item
          name="username"
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input placeholder="用户名" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password placeholder="密码" />
        </Form.Item>

        <Form.Item name="rememberMe" valuePropName="checked">
          <Checkbox>记住我</Checkbox>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            登录
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login; 